import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAppContext } from "../../AppContext";
import {
  OngoingSupportNames,
  OngoingSupportPackage,
  ProductTypes,
  ongoingSupportPackages,
} from "../../file.interface";
import { formatAsEuro } from "../../helpers/helpers";
import { ScreenContainer } from "../../components/containers";

const SupportScreen7: React.FC = () => {
  const { selectedOngoingSupportPackage, sites, dispatch } = useAppContext();
  const navigate = useNavigate();
  const [customOngoingSupportPackage, setCustomOngoingSupportPackage] =
    useState<OngoingSupportPackage[] | null>(null);

  useEffect(() => {
    // Calculate ongoing support packages
    const customPackages = ongoingSupportPackages.map((_package, i) => {
      let packagePrice: number = 0;
      if (
        _package.packageName === OngoingSupportNames.premium ||
        _package.packageName === OngoingSupportNames.elite
      ) {
        let cartItemsPerSite = sites.map((site) => {
          let _terminalsCounter = site.cart.filter(
            (p) => p.type === ProductTypes.Terminals
          ).length;
          //console.log("_terminalsCounter", _terminalsCounter);
          let _eposCounter = site.cart.filter(
            (p) => p.type === ProductTypes.Epos
          ).length;
          /*      if (_eposCounter > 0) {
            _eposCounter = _eposCounter * 2; //adding the terminals included for each device
          } */
          return _eposCounter + _terminalsCounter;
        });

        packagePrice = cartItemsPerSite.reduce(
          (total, currentDeviceCount) =>
            _package.getPrice(currentDeviceCount) + total,
          0
        );
      }
      return {
        ..._package,
        calculatedPrice: packagePrice,
      };
    });

    setCustomOngoingSupportPackage(customPackages);
  }, [sites]);

  const handleOngoingSupport = (item: OngoingSupportPackage): void => {
    dispatch({
      type: "UPDATE_CONTEXT",
      payload: { selectedOngoingSupportPackage: item },
    });
  };

  return (
    <ScreenContainer
      title="Ongoing Support"
      subtitle="Choose one of the following packages"
    >
      <div className="package-container">
        {customOngoingSupportPackage?.map((_package, i) => {
          //
          let formattedPrice = formatAsEuro(_package.calculatedPrice);
          if (_package.packageName === OngoingSupportNames.standard)
            formattedPrice = "FREE";
          if (_package.packageName === OngoingSupportNames.buildYourOwn)
            formattedPrice = "";

          return (
            <div
              key={i}
              className={`${
                _package.packageName ===
                selectedOngoingSupportPackage?.packageName
                  ? "card-package-selected"
                  : ""
              } card-package`}
              onClick={() => handleOngoingSupport(_package)}
            >
              <div className="price-section">
                <div className="orange-title">{_package.packageName}</div>
                <div className="package-price">{formattedPrice}</div>
              </div>
              <ul>
                {_package.description.split("\n").map((line, i) => (
                  <li key={i}>{line}</li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>

      <div className="buttons-container">
        <button
          className="app-button previous-button"
          onClick={() => navigate(-1)}
        >
          Previous
        </button>
        {selectedOngoingSupportPackage && (
          <button
            className="app-button next-button"
            onClick={() => navigate("/estimation-screen-7")}
          >
            Next
          </button>
        )}
      </div>
    </ScreenContainer>
  );
};

export default SupportScreen7;
